<template>
  <div class="user-container">
    <nav class="add-navigation">
      <div class="custom-row w-75">
        <div class="col col-lg-4 col-md-5 col-xs-12">
          <search-input
            class="search-input"
            type="text"
            v-model="SearchUser"
            placeholder="Search for user"
          />
        </div>
        <div class="show-active-items">
          <input type="checkbox" id="show-active" class="active-checkbox" v-model="isActive" />
          <label for="show-active">Active Only</label>
        </div>
      </div>

      <div class="buttons-wrapper">
        <div class="primary-button">
          <primary-button @click.native="$router.push({name: 'reseller-user-add'})">Add User</primary-button>
        </div>
      </div>
    </nav>

    <not-found v-if="isFound" />
    <div v-else class="table_div" style="width:100%;overflow-x:auto;overflow-y:hidden">
      <table class="table table-bordered table-striped table-responsive-md">
        <thead>
          <tr>
            <th>User</th>
            <th>Created On</th>
            <th>Password</th>
            <th>Status</th>
            <th class="action">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(user, k) in users"
            :class="{'active': user.status === 'active', 'inactive': user.status === 'inactive'}"
            :key="k"
          >
            <td style="min-width: 100px">
              <div @click="changeStatus(user)" class="status"></div>
              {{user.user_name}}
            </td>
            <td style="min-width: 120px">{{new Date(user.created_on).toDateString()}}</td>
            <td style="min-width: 120px">{{user.passwd}}</td>
            <td style="min-width: 70px">{{user.status}}</td>
            <td class="btns action">
              <button class="btn btn-sm p-0" @click="showAllowanceModal = true">
                <span title="Allowance">
                  <img src="../../../assets/Icon/Credit-Icon-2.png" alt="Allowance" width="30px"/>
                </span>
              </button>
              <svg
                @click="$router.push({name: 'reseller-user-edit', params: {id: user.user_id}})"
                class="svg-grey edit"
                width="30px"
                height="30px"
                viewBox="0 0 30 30"
                version="1.1"
              >
                <path
                  d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
                  id="path-1"
                />
              </svg>
              <svg
                @click="deleteUser(user.user_id)"
                class="svg-grey delete"
                width="30px"
                height="30px"
                viewBox="0 0 30 30"
                version="1.1"
              >
                <path
                  d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
                  id="path-1"
                />
              </svg>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col col-lg-6 col-md-7 col-xs-12 per-page">
      <span style="margin: -5px 15px 0 0" class="filter_by">Show Per Page:</span>
      <div class="primary-input-container choose-type perPage">
        <primary-select
          type="text"
          @input="changePerPage"
          v-model="per_page" :is-cross="false"
          class="choose-type perPage"
          placeholder="Select"
        >
          <option :value="item" v-for="(item,key) in pages" :key="key">{{item}}</option>
        </primary-select>
      </div>
    </div>
    <div v-if="!isFound" class="buttons-wrapper">
      <pagination-component
        @change-page="changePage($event)"
        :page="Page"
        :total="TotalPages"
        :per-page="per_page"
        :qnt="users.length"
      />
    </div>
    <Modal class="modal-size" v-if="showAllowanceModal" @close="showAllowanceModal = null">
      <h3 slot="header"></h3>
      <div slot="body">
        <form class="form">
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="col-md-12 field-width">
                <table class="table table-bordered w-100 table-responsive-lg">
                  <thead>
                    <tr>
                      <th style="width:170px">Country</th>
                      <th class="modal-table-count">Count</th>
                      <th class="modal-table-action">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colspan="2"></td>
                      <td>
                        <button class="btn btn-primary btn-sm" @click.prevent="newRow = true">+</button>
                      </td>
                    </tr>
                    <tr v-for="(item,key) in popUpData" :key="key">
                      <td style="min-width: 150px">
                        <div class="form-group" v-if="showRow == key">
                          <primary-select
                            type="text"
                            class="did"
                            v-model="editRow.country"
                            placeholder="Country"
                          >
                            <option value disabled hidden selected>Select Country</option>
                            <option :value="i" v-for="(i,k) in country" :key="k">{{i}}</option>
                          </primary-select>
                        </div>
                        <span v-if="showRow != key">{{item.country}}</span>
                      </td>
                      <td class="modal-table-count">
                        <div class="form-group" v-if="showRow == key">
                          <primary-input
                            type="number"
                            class="field"
                            v-model="editRow.count"
                            v-validate="'required'"
                            :class="{'input': true, 'is-danger': errors.has('count')}"
                            placeholder="Count"
                          />
                          <div
                            class="help is-danger"
                            v-if="errors.has('count')"
                          >{{ errors.first('count') }}</div>
                        </div>
                        <span v-if="showRow != key">{{item.count}}</span>
                      </td>
                      <td class="modal-table-action">
                        <button
                          class="btn btn-secondary btn-sm mr-2"
                          @click.prevent="showEditRow(item,key)"
                          v-if="showRow != key"
                        >Edit</button>
                        <button
                          class="btn btn-secondary btn-sm mr-2"
                          @click.prevent="editNewRow(key)"
                          v-if="showRow == key"
                        >Add</button>
                        <!-- <button
                          class="btn btn-danger btn-sm mr-2"
                          @click.prevent="deleteRow(key)"
                          v-if="showRow != key"
                        >Delete</button>-->
                        <button
                          class="btn btn-primary btn-sm"
                          @click.prevent="newRow = true"
                          v-if="showRow != key"
                        >+</button>
                      </td>
                    </tr>

                    <tr v-if="newRow">
                      <td>
                        <div class="form-group">
                          <primary-select
                            type="text"
                            class="did"
                            v-model="countryName"
                            placeholder="Country"
                          >
                            <option value disabled hidden selected>Select Country</option>
                            <option
                              :value="i"
                              v-for="(i,k) in country"
                              :key="k"
                              :disabled="countryName"
                            >{{i}}</option>
                          </primary-select>
                        </div>
                      </td>
                      <td>
                        <div class="form-group">
                          <primary-input
                            type="number"
                            class="field"
                            v-model="count"
                            v-validate="'required'"
                            :class="{'input': true, 'is-danger': errors.has('count')}"
                            placeholder="Count"
                          />
                          <div
                            class="help is-danger"
                            v-if="errors.has('count')"
                          >{{ errors.first('count') }}</div>
                        </div>
                      </td>
                      <td>
                        <button class="btn btn-secondary btn-sm mr-2" @click.prevent="addNew">Add</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div slot="footer" class="m-top-100">
        <button @click="cancelBtn" class="btn btn-block cancel">Cancel</button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { format } from "date-fns";

import axios from "axios";

export default {
  name: "UserListing",
  components: {
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    Modal: () => import("@/components/Modal.vue"),
    NotFound: () => import("@/components/NotFound.vue"),
  },
  data() {
    return {
      users: [],
      SearchUser: "",
      count: null,
      // country: ["US", "China", "Russia", "Italy", "Spain"],
      country: [],
      countryName: null,
      popUpData: [
        // { country: "China", count: 100 },
      ],
      editRow: [{ country: "", count: "" }],
      showRow: null,
      newRow: false,
      Page: 0,
      TotalPages: null,
      pages: [10, 20, 50, 100, 200],
      per_page: 10,
      showAllowanceModal: null,
      api: "http://88.198.219.62/api_smsc/v1",
      isFound: false,
      isActive: false,
    };
  },
  created() {
    this.getUsersList();
  },
  watch: {
    SearchUser() {
      this.Page = 0;
      this.getUsersList();
    },
    isActive() {
      this.Page = 0;
      this.getUsersList();
    },
  },
  methods: {
    cancelBtn() {
      this.popUpData = [];
      this.newRow = false;
      this.showAllowanceModal = null;
    },
    deleteUser(userId) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this user!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("DeleteUser", userId)
            .then((res) => {
              this.getUsersList();
              this.$swal("Deleted!", "Your user has been deleted.", "success");
            })
            .catch((err) => {
              this.$snotify.error(err.response.statusText);
            });
        }
      });
    },
    getUsersList() {
      this.isFound = false;
      this.$store
        .dispatch("GetUsersListing", {
          page: this.Page,
          full_name: this.SearchUser,
          is_active: this.isActive,
        })
        .then((res) => {
          if (!res.items.length && !this.SearchUser && !this.isActive) {
            this.$router.push({ name: "reseller-user-add" });
            return;
          }
          if (!res.items.length) {
            this.isFound = true;
            return;
          }
          this.Page = res.page;
          this.TotalPages = res.total / res.per_page;
          this.users = res.items;
        });
    },
    changePage(page) {
      this.Page = page;
      this.getUsersList(this.SearchUser, this.Page);
    },
    changePerPage(e) {
      this.Page = 0;
      this.getUsersList();
    },
    addNew() {
      let obj = {
        country: this.countryName,
        count: this.count,
      };
      this.popUpData = [...this.popUpData, obj];
      this.newRow = false;
    },
    // deleteRow(index) {
    //   let data = [...this.popUpData];
    //   data.splice(index, 1);
    //   console.log(data);
    //   this.popUpData = data;
    // },
    showEditRow(item, key) {
      this.showRow = key;
      this.editRow.country = item.country;
      this.editRow.count = item.count;
    },
    editNewRow(key) {
      let data = [...this.popUpData];
      data[key].country = this.editRow.country;
      data[key].count = this.editRow.count;
      this.popUpData = data;
      this.showRow = null;
    },
    changeStatus(user) {
      if (user.status === "active") {
        user.status = "inactive";
        user.is_active = false;
      } else if (user.status === "inactive") {
        user.status = "active";
        user.is_active = true;
      }
      this.$store
        .dispatch("ChangeUserStatusListing", {
          user_id: user.user_id,
          is_active: user.is_active,
        })
        .then((res) => {
          this.$snotify.success("User status was changed.", {
            timeout: 6000,
          });
          this.getUsersList();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.btns {
  display: flex;
  justify-content: center;
  align-items: center;

  .edit {
    margin: 0 10px;
  }
  svg {
    cursor: pointer;
  }
}
.user-container {
  font-family: "Helvetica Neue";
  padding: 0 20px;

  .show-active-items {
    display: flex;
    align-items: center;
    margin-left: 20px;
    // padding: 15px 0;

    .active-checkbox {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
    label {
      margin-bottom: 0;
    }
  }
  .table {
    th,
    td {
      text-align: center;
    }

    .action {
      width: 200px;
    }
  }
  .per-page {
    display: flex;
    align-items: center;
    margin-top: 20px;
    padding: 0;
  }
  .perPage {
    width: 120px;
    display: inline-block;
  }

  .custom-row {
    margin-right: 10px;
    display: flex;
    /*margin-left: 20px;*/

    .col.col-lg-4 {
      padding-left: 0;
    }
  }

  .buttons-wrapper {
    justify-content: flex-end !important;
  }

  .user-container .add-navigation .right-wrapprr .search-input {
    width: 100% !important;
  }

  table thead tr {
    background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
  }

  .btn-primary {
    background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
    border-color: #51a3f3;
  }

  table thead tr th {
    color: white;
    padding-left: 10px;
  }

  @media (max-width: 891px) {
    .right-wrapprr {
      width: 100% !important;
    }
  }
  @media (max-width: 767px) {
    .add-navigation {
      display: block !important;
      height: auto !important;
    }
    .buttons-wrapper {
      justify-content: flex-start !important;
      margin-top: 15px;
    }
  }
  @media (max-width: 600px) {
    .right-wrapprr {
      display: block !important;
    }
    .buttons-wrapper {
      width: 100% !important;
    }
    .col-lg-6.col-md-7.col-xs-12 {
      margin-top: 15px;
    }
  }
  .add-navigation {
    font-family: "Helvetica Neue";
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .search-input {
      height: 40px;
      width: 100%;
      background-color: #ffffff;
    }
    .primary-button {
      height: 40px;
      width: 150px;
    }
  }
}

table tr th {
  padding: 12px 0;
  font-size: 16px;
  color: #212b36;
  font-family: "Helvetica Neue";
  line-height: 20px;
  font-weight: normal;
}

tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 20px;
  padding: 12px 10px;
  text-align: left;
}

.radio-button {
  height: 30px;
  width: 50px;
  border-radius: 15px;
  background-color: #ffffff;
  border: 1px solid #a6b6be;
  margin-right: 20px;
  padding: 1px 23px 3px 3px;
  cursor: pointer;

  svg {
    height: 24px;
    width: 24px;
    // box-shadow: 2px 2px 7px 0 rgba(77,84,94,0.24);
  }
}

.radio-button.active {
  padding: 2px 3px 3px 23px;
  background-color: #24e2b8;
  border: 0;
}

.status {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-grid;
  margin: 0 10px 0 12px;
  float: left;
}

.active {
  td .status {
    background-color: #24e2b8;
  }
}

.inactive {
  background-color: #f0f1fa;

  td .status {
    background-color: #d2305b;
  }
}

.cancel {
  border: 1px solid #ccc;
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}

@media screen and (max-width: 1300px) {
  table.table {
    width: 1200px;
  }
}
</style>
<style>
.modal-size .modal-container {
  width: 44% !important;
}
.modal-size .table .modal-table-count {
  width: 100px;
}
.modal-size .modal-table-action {
  width: 80px;
}

@media (max-width: 1600px) {
  .modal-size .modal-container {
    width: 43% !important;
  }
}
@media (max-width: 1400px) {
  .modal-size .modal-container {
    width: 48% !important;
  }
}
@media (max-width: 1250px) {
  .modal-size .modal-container {
    width: 51% !important;
  }
}
@media (max-width: 1120px) {
  .modal-size .modal-container {
    width: 56% !important;
  }
}

@media (max-width: 900px) {
  .modal-size .modal-container {
    width: 74% !important;
  }
}
</style>
